import React from "react";
import "./component-css/LearningMaterials.css";

const EconomicsAndManagement = () => {
        const materials = [
            {
                title: "Sustainability in Higher Education and Curriculum Design",
                type: "pdf",
                link: "/materials/economics-and-management/HNEE_English.pdf",
                description:
                    "A short introduction to how universities integrate sustainability into teaching, course planning, and student competencies, with a focus on the skills needed to support sustainable development."
            },
            {
                title: "Importance of Sustainable Tourism: Frameworks and Guidelines",
                type: "youtube",
                link: "https://youtu.be/06iBplXYQdo",
                description:
                    "An overview of key frameworks and guidelines for promoting sustainable tourism and responsible development practices."
            },
            {
                title: "Circular Economy and Millennium Goals",
                type: "youtube",
                link: "https://youtu.be/nAenqhyPjwY",
                description:
                    "An overview of how circular economy principles contribute to achieving broader sustainability and development goals."
            },
            {
                title: "Sustainable Development and SDGs",
                type: "youtube",
                link: "https://youtu.be/PwY2204UeqI",
                description:
                    "Overview of sustainable development principles and UN SDGs, focusing on environmental, social, and economic sustainability."
            },
            {
                title: "Financial Recovery of Albanian Businesses under Uncertainty",
                type: "youtube",
                link: "https://youtu.be/GpkzAUGM1MI",
                description:
                    "Analysis of how Albanian businesses recover financially in uncertain and risk-driven economic conditions."
            },
            {
                title: "What is a Project?",
                type: "youtube",
                link: "https://youtu.be/X9dmqvmbQFk",
                description:
                    "Explanation of project concepts and definitions based on PMI and ISO standards."
            },
            {
                title: "Crisis Management in Tourism",
                type: "youtube",
                link: "https://youtu.be/P148FNxAb50",
                description:
                    "Strategies for building resilient and sustainable tourism communities during crises."
            },
            {
                title: "Climate Change and Tourism",
                type: "youtube",
                link: "https://youtu.be/20JqdQbm0F0",
                description:
                    "Understanding the impact of climate change on tourism and sustainable development."
            },
            {
                title: "Voluntourism",
                type: "youtube",
                link: "https://youtu.be/EY1uaUB1eu0",
                description:
                    "Exploring sustainable tourism through volunteer-driven travel and community engagement."
            }
        ];
    return (
        <div className="content-page lm-page">
            <header className="lm-header">
                <h1 className="lm-title">Economics and Management Learning Materials</h1>
                <p className="lm-subtitle">
                    Guides and videos on sustainable economics, project management,
                    and responsible development across sectors.
                </p>
            </header>

            <div className="lm-list">
                {materials.map((m, index) => (
                    <div key={index} className="lm-card">
                        <h3 className="lm-card-title">{m.title}</h3>

                        <p className="lm-card-desc">{m.description}</p>

                        <a
                            href={m.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="lm-card-link"
                        >
                            {m.type === "pdf" ? "📄 Open PDF" : "▶ Watch Video"}
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EconomicsAndManagement;
